module.exports = __webpack_public_path__ + "img/logo_ibero_blanco.202eff14.png";